import React from "react";
import { Box, Button } from "@mui/material";
import { FormattedMessage } from "react-intl";

function SurveyActions({ mode, onSubmit, onCancel }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        mt: { xs: 2, sm: 4 },
        px: { xs: 2, sm: 0 }
      }}
    >
      <Button
        onClick={onCancel}
        variant="contained"
        fullWidth={{ xs: true, sm: false }}
        sx={{
          border: "1px solid #00438E",
          color: "#00438E",
          backgroundColor: "transparent",
          "&:hover": { backgroundColor: "#003A75", color: "white" },
          textTransform: "none",
          py: { xs: 1.5, sm: 1 },
          fontSize: { xs: "0.9rem", sm: "0.875rem" },
          maxWidth: { xs: "100%", sm: "200px" },
        }}
      >
        <FormattedMessage id="survey.cancel" />
      </Button>
      <Button
        onClick={onSubmit}
        variant="contained"
        fullWidth={{ xs: true, sm: false }}
        sx={{
          backgroundColor: "#00438E",
          "&:hover": { backgroundColor: "#003A75" },
          textTransform: "none",
          py: { xs: 1.5, sm: 1 },
          fontSize: { xs: "0.9rem", sm: "0.875rem" },
          maxWidth: { xs: "100%", sm: "200px" },
        }}
      >
        {mode === "create" ? <FormattedMessage id="survey.save_survey" /> : <FormattedMessage id="survey.update_survey" />}
      </Button>
    </Box>
  );
}

export default SurveyActions;
